import React from "react";
import styles from "./Modal.module.css";

interface ModalButtonsProps {
  buttonCount: 1 | 2 | 3; // 버튼 개수 (1개, 2개, 3개 제한)
  buttons: {
    label: string;
    color?: "Primary" | "Secondary" | "Danger"; // 버튼 색상
    onClick?: () => void;
    disabled?: boolean;
  }[];
}

const ModalButtons: React.FC<ModalButtonsProps> = ({ buttonCount, buttons }) => {
  
  return (
    <div className={styles[`modalButtonsCount${buttonCount}`]}>
      {buttons.map((button, index) => (
        <button
          key={index}
           className={`${styles.modalButton} 
                       ${styles["modalButton" + (button.color || "Primary")]} 
                       ${button.disabled ? styles.modalButtonDisabled : ""}`}
          onClick={button.onClick}
          disabled={button.disabled}
          >
          {button.label}          
        </button>
      ))}
    </div>
  );
};

export default ModalButtons;
